// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TrustpilotSection_wrapper__KnIC9","microstarWrapper":"TrustpilotSection_microstarWrapper__Z3Y5_"};